import request from '@/request'

export async function getCardsByUser (userId) {
	const response = await request({
		url: `/users/${userId}/cards`,
		method: 'get'
	})

	return response.data.data
}

export async function createCardByUser (userId, data) {
	const response = await request({
		url: `/users/${userId}/cards`,
		method: 'post',
		data
	})

	return response.data.data
}

export async function updateCardByUser (userId, userCardId, data) {
	const response = await request({
		url: `/users/${userId}/cards/${userCardId}`,
		method: 'post',
		data: { _method: 'PUT', ...data }
	})

	return response.data.data
}

export async function deleteCardByUser (userId, userCardId) {
	await request({
		url: `/users/${userId}/cards/${userCardId}`,
		method: 'delete'
	})
}